import createSagaMiddleware from "@redux-saga/core";
import { applyMiddleware, configureStore } from "@reduxjs/toolkit";
import counterReducer from "./CounterSlice";
import propertiesReducer from "./properties/PropertiesSlice";
import prodcutsReducer from "./products/slice";
import userReducer from "./user/slice";
import optionsReducer from "./options/slice";
import rootSaga from "./rootsaga";
import languageReducer from "./languageSlice";
import transferReducer from "./transfer/slice";
import eudrReducer from "./eudr/slice";


// Initialize language from localStorage, browser language, or default to 'en'
const getInitialLanguage = () => {
  try {
    // Check localStorage first
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      return JSON.parse(storedLanguage);
    }
    
    // Detect browser language
    const browserLang = navigator.language || navigator.userLanguage;
    const langCode = browserLang.split('-')[0]; // 'es-MX' → 'es', 'en-US' → 'en'
    
    // Return browser language if supported, otherwise default to English
    const supportedLanguages = ['en', 'es', 'fr'];
    if (supportedLanguages.includes(langCode)) {
      console.log(`Browser language detected: ${langCode}`);
      return langCode;
    }
    
    return 'en';
  } catch (error) {
    console.error('Error loading language:', error);
    return 'en';
  }
};

const preloadedState = {
  language: getInitialLanguage()
};

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    properties: propertiesReducer,
    products: prodcutsReducer,
    user: userReducer,
    options: optionsReducer,
    language: languageReducer,
    transfer: transferReducer,
    eudr: eudrReducer,
  },
  preloadedState,
  middleware: (gDM) => gDM().concat([sagaMiddleware]),
  devTools: process.env.NODE_ENV !== "production",
});

sagaMiddleware.run(rootSaga);

export default store;
